module.exports = __webpack_public_path__ + "static/img/tjsp4.8dfa5a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/tjsp4.png
// module id = 391
// module chunks = 0